export const firstWorldCountries = [
    'AE',
    'AT',
    'AU',
    'AW',
    'AZ',
    'AZ',
    'BE',
    'BH',
    'BM',
    'BN',
    'BS',
    'CA',
    'CH',
    'CN',
    'CY',
    'CZ',
    'DE',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FO',
    'FR',
    'GB',
    'GI',
    'GR',
    'HK',
    'HR',
    'HU',
    'IE',
    'IL',
    'IS',
    'IT',
    'JP',
    'KR',
    'KW',
    'KZ',
    'LT',
    'LU',
    'LV',
    'MT',
    'MX',
    'MY',
    'NL',
    'NO',
    'NZ',
    'OM',
    'PL',
    'PR',
    'PT',
    'QA',
    'RU',
    'SA',
    'SE',
    'SG',
    'SI',
    'SK',
    'SK',
    'TW',
    'US',
    'UZ',
    'MV',
    'FJ',
    'MU',
    'VG',
    'MO',
    'TJ',
    'KG',
    'PA',
    'UA',
    'IQ',
]
